export function clientChargeBreakdown(amount, percent) {
    const gross = Math.round((Number(amount) || 0) * 100) / 100;
    const rate = Number(percent) || 0;
    let chargeAmount = Math.round((gross * rate / 100) * 100) / 100;
    if (chargeAmount < 0) chargeAmount = 0;
    if (chargeAmount > gross) chargeAmount = gross;
    const net = Math.round((gross - chargeAmount) * 100) / 100;
    return { gross, percent: rate, chargeAmount, net };
}

export function formatMoney(value) {
    return `$${Number(value || 0).toFixed(2)}`;
}

export function formatFeePercent(fee) {
    const percent = Number(fee);
    if (!Number.isFinite(percent)) return "0%";
    const rounded = Math.round(percent * 100) / 100;
    return `${Number.isInteger(rounded) ? rounded.toFixed(0) : rounded}%`;
}

export function parseGatewayFeePercent(fee) {
    if (fee == null || fee === '' || fee === 'Free') return 0;
    if (typeof fee === 'number') return Number.isFinite(fee) ? fee : 0;
    const match = String(fee).replace(/,/g, '').match(/-?\d+(\.\d+)?/);
    return match ? Number(match[0]) : 0;
}

export function effectiveChargePercent(clientPercent, gatewayFee) {
    if (clientPercent !== null && clientPercent !== undefined && clientPercent !== "") {
        const client = Number(clientPercent);
        if (Number.isFinite(client)) return client;
    }
    return parseGatewayFeePercent(gatewayFee);
}

export function chargePercentForGateway(charges, gatewayId) {
    if (!gatewayId || !Array.isArray(charges)) return null;
    const match = charges.find(
        (item) => String(item?.paymentGatewayId).toLowerCase() === String(gatewayId).toLowerCase(),
    );
    if (!match || match.chargePercent === null || match.chargePercent === undefined || match.chargePercent === "") {
        return null;
    }
    const percent = Number(match.chargePercent);
    return Number.isFinite(percent) ? percent : null;
}
